import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Image from 'react-bootstrap/Image';
import { toast } from 'react-toastify';
import { extendMoment } from 'moment-range';
import originalMoment from 'moment';
import loadable from '@loadable/component';
import concat from 'ramda/src/concat';
import filter from 'ramda/src/filter';
import find from 'ramda/src/find';
import isEmpty from 'ramda/src/isEmpty';
import isNil from 'ramda/src/isNil';
import propEq from 'ramda/src/propEq';
import Avatar from '@components/@core/Avatar';
import Button from '@components/@core/AnimatedButton';
import DatePicker from '@components/@core/DatePicker';
import ErrorBoundary from '@components/@core/ErrorBoundary';
import Icon from '@components/@core/Icon';
import Pagination from '@components/@core/Pagination';
import Rating from '@components/@core/Rating';
import Thumbnail from '@components/@core/Thumbnail';
import AppActions from '~/actions/app';
import CompanyActions from '~/actions/company';
import VendorActions from '~/actions/vendor';
import { convertUrl, hasHtml, isImageURL } from '~/services/util';
import withNavigate from '~/hocs/withNavigate';

const moment = extendMoment(originalMoment);
const ReactPlayer = loadable(() => import('react-player'), { ssr: false });

class ByCategoryDetail extends Component {
    constructor(props) {
        super(props);
        this.state = {
            categoryId: Number(props.match?.params?.id || 0),
            category: null,
            dateStart: moment().subtract(2, 'years').format('YYYY-MM-DD'),
            dateEnd: moment().format('YYYY-MM-DD'),
        };
    }

    static getDerivedStateFromProps(nextProps, prevState) {
        const { categoryId, dateStart, dateEnd } = prevState;
        const { categories, getDetail } = nextProps;
        const category = find(propEq('id', categoryId), categories);
        if (!category) {
            getDetail({
                categoryId,
                payload: { per_page: 25, page: 1, date_start: dateStart, date_end: dateEnd },
            });
        }
        return { category };
    }

    getCategoryProducts = (per_page, page, date_start, date_end) => {
        const { categoryId } = this.state;
        this.props.getDetail({ categoryId, payload: { per_page, page, date_start, date_end } });
    };

    handleChangePage = (page) => {
        const { category, dateStart, dateEnd } = this.state;
        const { products } = category;
        this.getCategoryProducts(products.per_page, page, dateStart, dateEnd);
    };

    handleChangePer = (perPage) => {
        const { category, dateStart, dateEnd } = this.state;
        const { products } = category;
        this.getCategoryProducts(perPage, products?.current_page || 1, dateStart, dateEnd);
    };

    handleOpenDetail =
        (product, from = 'product') =>
        () => {
            const { category } = this.state;
            const { parent } = product;
            if (parent.business_id) {
                window.location = `/${product.parent.slug}/${product.slug}`;
                const payload = { id: parent.business_id };
                const link = from === 'product' ? `${product.slug}?id=${parent.business_id}&category=${category.id}` : `about?id=${parent.business_id}`;
                const route = `/business/${link}`;
                this.props.getBusiness(payload, route);
                this.props.getPopular(category.id);
            } else {
                toast.error('This product does not have business yet. Please reach out to Brandon!', {
                    position: toast.POSITION.TOP_RIGHT,
                    pauseOnFocusLoss: false,
                    hideProgressBar: true,
                });
            }
        };

    handleRateProduct = (product) => () => {
        const { loginUser } = this.props;
        const { category, dateStart, dateEnd } = this.state;
        const modalPayload = {
            per_page: category.products.per_page,
            page: category.products?.page,
            date_start: dateStart,
            date_end: dateEnd,
        };
        const payload = {
            type: 'Rate Vendor',
            data: { before: { tab: 'category', product: product.id, category: category.id, payload: modalPayload } },
        };
        if (loginUser?.id) {
            if (String(loginUser?.profile?.member_type) !== '0') {
                toast.error('Sorry, only dealers can leave reviews.', {
                    position: toast.POSITION.TOP_RIGHT,
                    pauseOnFocusLoss: false,
                    hideProgressBar: true,
                });
                return;
            }
            this.props.toggleModal(payload);
        } else {
            const { location } = this.props;
            const route = `${location.pathname}${location.search}`;
            const after = { type: 'MODAL_REQUEST', payload };
            this.props.toggleModal({
                type: 'Authentication',
                data: { before: { route, after } },
            });
        }
    };

    handleDateChange = (e) => {
        const dateStart = e.start.format('YYYY-MM-DD');
        const dateEnd = e.end.format('YYYY-MM-DD');
        const { products } = this.state.category;
        this.setState({ dateStart, dateEnd });
        this.getCategoryProducts(products?.per_page || 25, products?.current_page || 1, dateStart, dateEnd);
    };

    render() {
        const { category, dateStart, dateEnd } = this.state;
        if (isNil(category)) return null;
        const { name, description, products } = category;
        const premium = filter((x) => x.data?.sponsored_level === 'gold', products?.data || []);
        const plus = filter((x) => x.data?.sponsored_level === 'silver', products?.data || []);
        const featured = concat(premium, plus);
        const standard = filter((x) => x.data?.sponsored_level !== 'gold' && x.data?.sponsored_level !== 'silver', products?.data || []);

        return (
            <ErrorBoundary className="vendor-rating-category-detail">
                <div className="d-h-between mb-2">
                    <div className="d-flex align-items-center">
                        <Button className="btn-vendor-ratings" type="link" name="Vendor Ratings" onClick={() => this.props.navigate('/vendor-ratings')} />
                        <Icon name="fas fa-chevron-right mx-2" size={12} color="#969faa" />
                        <Button className="btn-vendor-ratings" type="link" name="By Category" onClick={() => this.props.navigate(-1)} />
                        <p className="dsl-m14 mb-0">
                            <Icon name="fas fa-chevron-right mx-2" size={12} color="#969faa" />
                            {`${name}`}
                        </p>
                    </div>
                    <Button className="btn-vendor-ratings" type="link" onClick={() => this.props.navigate(-1)}>
                        <div className="d-flex align-items-center">
                            <Icon name="far fa-arrow-left me-2" color="#376caf" size={14} />
                            <p className="dsl-p14 mb-0">Back to all the categories</p>
                        </div>
                    </Button>
                </div>
                <Row className="m-0">
                    <Col xs={7} className="category-detail">
                        <div className="category-detail-contents">
                            <p className="dsl-b18 bold">{name}</p>
                            {hasHtml(description) ? <div className="dsl-b16" dangerouslySetInnerHTML={{ __html: description }} /> : <p className="dsl-b16">{description}</p>}
                        </div>
                    </Col>
                    <Col xs={5} className="category-logo">
                        <Row className="m-0">
                            <Col lg={10} className="pl-0">
                                <Image src="/images/DSA_logo.png" className="w-100" />
                            </Col>
                        </Row>
                    </Col>
                </Row>
                {featured && (
                    <div className="featured-list mt-2">
                        <div className="d-flex jc-between">
                            <div className="featured-list-title">
                                <p className="dsl-b18 bold mb-1">Featured Products</p>
                            </div>
                            <div className="datepicker">
                                <DatePicker
                                    calendar="range"
                                    append="caret"
                                    format="MMM D, YY"
                                    as="span"
                                    align="right"
                                    mountEvent
                                    closeAfterSelect
                                    value={moment.range(dateStart, dateEnd)}
                                    onSelect={this.handleDateChange}
                                />
                            </div>
                        </div>
                        {featured.map((product, index) => {
                            const { name, logo, stats, data, parent } = product;
                            const description = (data?.description ?? '').replace(/(<([^>]+)>)/gi, '');
                            const recommended = Math.round((stats?.rating_recommended_avg ?? 0) * 100) / 100;
                            const score = Math.round(Number(stats?.rating_avg) * 100) / 100;
                            const videos = (Array.isArray(data?.videos) ? data.videos : [])?.filter((e) => !isEmpty(e) && !isNil(e)).slice(0, 6);
                            return (
                                <div className="featured-list-product px-4" key={`featured-list-${index}`}>
                                    <Row className="border-bottom mx-0 py-4">
                                        <Col xs={'auto'} sm={2} className="px-0 user-img" onClick={this.handleOpenDetail(product)}>
                                            <Avatar
                                                defaultImg="/images/default_company.svg"
                                                name={name}
                                                url={logo}
                                                isSponsored={data.sponsored_level === 'gold' || data.sponsored_level === 'silver'}
                                                size="extraLarge"
                                                type="logo"
                                            />
                                        </Col>
                                        <Col xs={10} className="d-flex pe-0 by-cate-sm">
                                            <div className="product-details" onClick={this.handleOpenDetail(product)}>
                                                <p className="dsl-b18 text-400 mb-1">{name}</p>
                                                {stats?.rating_avg ? (
                                                    <div className="d-h-start pt-2 pb-3">
                                                        <Rating score={score} className="mr-2" />
                                                        <p className="dsl-b14 mb-0 mx-3">{`${recommended}% Recommended`}</p>
                                                        <p className="dsl-b14 mb-0">{`${stats?.rating_count} ratings`}</p>
                                                    </div>
                                                ) : (
                                                    <Button name="Leave first review" className="px-0 pt-0" type="link" />
                                                )}
                                                <p className="dsl-b16 mb-3">
                                                    {description.length > 199 ? (
                                                        <>
                                                            {`${description.substring(0, 200)}...`}
                                                            <Button className="p-0 ps-3" name="View more" type="link" />
                                                        </>
                                                    ) : (
                                                        description
                                                    )}
                                                </p>
                                                <div className="plus-media mx-0">
                                                    {videos.map((item, idx) => (
                                                        <div key={`media-item-${idx}`} className="plus-media-item">
                                                            {isImageURL(item) ? (
                                                                <Thumbnail source={convertUrl(item)} size="responsive" />
                                                            ) : (
                                                                <div className="video-media">
                                                                    <ReactPlayer url={item} width="100%" height="100%" />
                                                                </div>
                                                            )}
                                                        </div>
                                                    ))}
                                                    {[...Array(6 - videos.length).keys()].map((index) => (
                                                        <div key={`media-item-${index}`} className="plus-media-item"></div>
                                                    ))}
                                                </div>
                                            </div>
                                            <div className="company-contacts">
                                                <div className="w-100">
                                                    <p className="dsl-p14 text-end mb-2" onClick={this.handleOpenDetail(product, 'company')}>
                                                        {parent?.name || ''}
                                                    </p>
                                                    <p className="dsl-b14 text-sm-right mb-2 text-center">{data?.contact?.phone ? data.contact.phone : 'Phone not provided'}</p>
                                                </div>
                                                <div className="d-flex flex-column align-items-end">
                                                    <Button className="btn-company-contact" type="medium" name="Rate Vendor" onClick={this.handleRateProduct(product)} />
                                                    {/*<Button className="btn-company-contact" name="SPECIAL QUOTE" />*/}
                                                </div>
                                            </div>
                                        </Col>
                                    </Row>
                                </div>
                            );
                        })}
                    </div>
                )}
                {standard && (
                    <div className="featured-list mt-2">
                        <div className="featured-list-title">
                            <p className="dsl-b18 bold mb-1">Products</p>
                        </div>
                        {standard.map((product, index) => {
                            const { name, stats, data, parent } = product;
                            const description = (data?.description ?? '').replace(/(<([^>]+)>)/gi, '');
                            const recommended = Math.round((stats?.rating_recommended_avg ?? 0) * 100) / 100;
                            const score = Math.round(Number(stats?.rating_avg) * 100) / 100;
                            return (
                                <div className="featured-list-product px-4" key={`featured-list-${index}`}>
                                    <Row className="border-bottom mx-0 py-4">
                                        <Col xs={2} className="px-0 user-img" onClick={this.handleOpenDetail(product)}>
                                            <Avatar
                                                size="extraLarge"
                                                name={name}
                                                url={'/images/image-not-provided.jpg'}
                                                isSponsored={data.sponsored_level === 'gold' || data.sponsored_level === 'silver'}
                                                type="logo"
                                            />
                                        </Col>
                                        <Col xs={10} className="d-flex pe-0 by-cate-sm">
                                            <div className="product-details" onClick={this.handleOpenDetail(product)}>
                                                <p className="dsl-b18 text-400 mb-1">{name}</p>
                                                {stats?.rating_avg ? (
                                                    <div className="d-h-start pt-2 pb-3">
                                                        <Rating score={score} className="mr-2" />
                                                        <p className="dsl-b14 mb-0 mx-3">{`${recommended}% Recommended`}</p>
                                                        <p className="dsl-b14 mb-0">{`${stats?.rating_count} ratings`}</p>
                                                    </div>
                                                ) : (
                                                    <Button name="Leave first review" className="px-0 pt-0" type="link" />
                                                )}
                                                <p className="dsl-b16 mb-3">
                                                    {description.length > 199 ? (
                                                        <>
                                                            {`${description.substring(0, 200)}...`}
                                                            <Button className="p-0 ps-3" name="View more" type="link" />
                                                        </>
                                                    ) : (
                                                        description
                                                    )}
                                                </p>
                                            </div>
                                            <div className="company-contacts">
                                                <div className="w-100">
                                                    <p className="dsl-p14 text-end mb-2" onClick={this.handleOpenDetail(product, 'company')}>
                                                        {parent?.name || ''}
                                                    </p>
                                                    <p className="dsl-b14 text-sm-right mb-2 text-center">{data?.contact?.phone ? data.contact.phone : 'Phone not provided'}</p>
                                                </div>
                                                <div className="d-flex flex-column align-items-end">
                                                    <Button className="btn-company-contact" type="medium" name="Rate Vendor" onClick={this.handleRateProduct(product)} />
                                                    {/*<Button className="btn-company-contact" name="SPECIAL QUOTE" />*/}
                                                </div>
                                            </div>
                                        </Col>
                                    </Row>
                                </div>
                            );
                        })}
                    </div>
                )}
                {products && <Pagination per={products.per_page} current={products.page} total={products.last_page} onChange={this.handleChangePage} onPer={this.handleChangePer} />}
            </ErrorBoundary>
        );
    }
}

ByCategoryDetail.propTypes = {
    userId: PropTypes.number,
    categories: PropTypes.array,
    loginUser: PropTypes.shape({
        id: PropTypes.number,
        profile: PropTypes.shape({
            member_type: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
        }),
    }),
    getDetail: PropTypes.func,
    getCompanyDetail: PropTypes.func,
    toggleModal: PropTypes.func,
};

ByCategoryDetail.defaultProps = {
    userId: 0,
    categories: [],
    loginUser: null,
    getDetail: () => {},
    getCompanyDetail: () => {},
    toggleModal: () => {},
};

const mapStateToProps = (state) => ({
    userId: state.app.id,
    loginUser: state.app.user?.community_user,
    categories: state.vendor.categories.all,
});

const mapDispatchToProps = (dispatch) => ({
    getDetail: (e) => dispatch(VendorActions.getcategoryproductsRequest(e)),
    getCompanyDetail: (e) => dispatch(VendorActions.getvendorcompanyRequest(e)),
    getBusiness: (payload, route) => dispatch(CompanyActions.getbusinessRequest(payload, route)),
    getPopular: (e) => dispatch(VendorActions.getcategorypopularproductsRequest(e)),
    toggleModal: (e) => dispatch(AppActions.modalRequest(e)),
});

const ByCategoryDetailWithNavigate = withNavigate(ByCategoryDetail);

export default connect(mapStateToProps, mapDispatchToProps)(ByCategoryDetailWithNavigate);
